var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHistoryCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0C3.8866 0 4.2 0.313404 4.2 0.7V1.4H9.8V0.7C9.8 0.313404 10.1134 0 10.5 0C10.8866 0 11.2 0.313404 11.2 0.7V1.47001C12.7975 1.7943 14 3.20673 14 4.9C14 5.2866 13.6866 5.6 13.3 5.6H0.7C0.313404 5.6 0 5.2866 0 4.9C0 3.20673 1.20243 1.7943 2.8 1.47001V0.7C2.8 0.313404 3.1134 0 3.5 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.7 5.60156C0.313404 5.60156 0 5.8534 0 6.16406V10.6641C0 12.2174 1.56701 13.4766 3.5 13.4766H10.5C12.433 13.4766 14 12.2174 14 10.6641V6.16406C14 5.8534 13.6866 5.60156 13.3 5.60156H0.7Z",
    fill: "#CDD7D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 7.40826C3.5 7.03607 3.8134 6.73438 4.2 6.73438H9.8C10.1866 6.73438 10.5 7.03607 10.5 7.40826C10.5 7.78044 10.1866 8.08214 9.8 8.08214H4.2C3.8134 8.08214 3.5 7.78044 3.5 7.40826Z",
    fill: "#1C1C1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 10.1036C3.5 9.73138 3.8134 9.42969 4.2 9.42969H7C7.38661 9.42969 7.7 9.73138 7.7 10.1036C7.7 10.4758 7.38661 10.7775 7 10.7775H4.2C3.8134 10.7775 3.5 10.4758 3.5 10.1036Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistoryCalendarIcon);
export default __webpack_public_path__ + "static/media/payment-history-calendar-icon.8a0fd7ac3ee314430808d35c6e1f544a.svg";
export { ForwardRef as ReactComponent };